module.exports = __webpack_public_path__ + "static/media/ahm.e36c897b.jpg";